// EmailJS Configuration
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_vrr3hfa', // EmailJS service ID
  TEMPLATE_ID: 'template_6itigzd', // EmailJS template ID
  PUBLIC_KEY: 'FF4pwybJTIO-z-FNj', // EmailJS public key
};

// Email template parameters mapping
export const EMAIL_TEMPLATE_PARAMS = {
  from_name: 'from_name',
  from_email: 'from_email',
  company: 'company',
  salutation: 'salutation',
  title: 'title',
  first_name: 'first_name',
  last_name: 'last_name',
  telephone: 'telephone',
  reason: 'reason',
  subject: 'subject',
  message: 'message',
  to_email: 'info@votera.de', // Recipient email
};
